export default "__VITE_ASSET__CF5jUCqe__"